import { Link } from "react-router-dom";
import { ShieldCheck, Users, Radio, Film, Star } from "lucide-react";

const CARDS = [
  { label: "Review Creators", desc: "Approve or restrict creator applications", href: "/admin/creators", icon: Users, color: "green" },
  { label: "Manage Stations", desc: "Approve, restrict, or review radio stations", href: "/admin/stations", icon: Radio, color: "purple" },
  { label: "Review Content", desc: "Approve or reject uploaded content", href: "/admin/content", icon: Film, color: "green" },
  { label: "Featured Content", desc: "Manage homepage premiere and featured slots", href: "/admin/featured", icon: Star, color: "purple" },
];

export default function Admin() {
  return (
    <div data-testid="admin-dashboard" className="space-y-6">
      <div className="flex items-center gap-3 mb-2">
        <ShieldCheck size={22} className="text-[#B026FF]" />
        <div>
          <h1 className="text-2xl font-black text-white">Admin Panel</h1>
          <p className="text-zinc-500 text-sm">Manage the StagePass platform</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {CARDS.map(({ label, desc, href, icon: Icon, color }) => (
          <Link key={href} to={href} data-testid={`admin-card-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`bg-[#111] border border-white/5 rounded-2xl p-5 hover:bg-[#1a1a1a] transition-all ${
              color === "green" ? "hover:border-[#00ff77]/30" : "hover:border-[#B026FF]/30"
            }`}>
            <Icon size={20} className={color === "green" ? "text-[#00ff77] mb-3" : "text-[#B026FF] mb-3"} />
            <h3 className="text-white font-bold text-sm mb-1">{label}</h3>
            <p className="text-zinc-500 text-xs">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
